import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

function isNative() {
  return Capacitor.isNativePlatform();
}

export async function secureGet(key) {
  if (isNative()) {
    try {
      const { value } = await SecureStoragePlugin.get({ key });
      return value;
    } catch {
      return null;
    }
  }
  return localStorage.getItem(key);
}

export async function secureSet(key, value) {
  if (isNative()) {
    await SecureStoragePlugin.set({ key, value });
  } else {
    localStorage.setItem(key, value);
  }
}

export async function secureRemove(key) {
  if (isNative()) {
    try {
      await SecureStoragePlugin.remove({ key });
    } catch {
      // key might not exist
    }
  } else {
    localStorage.removeItem(key);
  }
}
